import { createI18n } from 'vue-i18n';
import en from './locales/en';
import lt from './locales/lt';

export type Locale = 'en' | 'lt';

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        en,
        lt
    }
});

export default i18n;
